import { useMutation, useQueryClient } from '@tanstack/react-query';

const invalidateMany = async (queryClient, invalidateKeys = []) => {
  await Promise.all(
    invalidateKeys
      .filter(Boolean)
      .map((key) => queryClient.invalidateQueries({ queryKey: key }))
  );
};

export const useRuntimeMutation = ({ mutationFn, invalidateKeys = [], onSuccess, onError, ...options }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    retry: 0,
    ...options,
    onSuccess: async (data, variables, context) => {
      await invalidateMany(queryClient, invalidateKeys);
      if (typeof onSuccess === 'function') {
        await onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (typeof onError === 'function') {
        onError(error, variables, context);
      }
    },
  });
};

export default useRuntimeMutation;